export default {
  "withdrawHistory.title": "提现审批",
  "withdrawHistory.thead.index": "#序号",
  "withdrawHistory.thead.merOrderno": "提款单号",
  "withdrawHistory.thead.applyId": "申请ID",
  "withdrawHistory.thead.whatsapp": "手机号",
  "withdrawHistory.thead.platform": "出款平台",
  "withdrawHistory.thead.userno": "会员ID",
  "withdrawHistory.thead.info": "提款信息",
  "withdrawHistory.thead.applyStatus": "处理状态",
  "withdrawHistory.thead.applyTime": "申请时间",
  "withdrawHistory.thead.createTimeFrom": "开始时间",
  "withdrawHistory.thead.createTimeTo": "结束时间",
  "withdrawHistory.thead.paymentOrderModifyTime": "完成时间",
  "withdrawHistory.thead.accountNo": "账号",
  "withdrawHistory.thead.accountName": "账户名",
  "withdrawHistory.thead.bankCode": "银行代码",
  "withdrawHistory.thead.email": "邮箱",
  "withdrawHistory.thead.remark": "备注",
  "withdrawHistory.thead.amount": "金额",
  "withdrawHistory.thead.payoutAmount": "派发金额",
  "withdrawHistory.thead.applyStatusDesc": "申请状态",
  "withdrawHistory.thead.payoutNum": "派发次数",
  "withdrawHistory.thead.ipRepeatNum": "IP重复次数",
  "withdrawHistory.thead.platformDesc": "平台",
  "withdrawHistory.thead.platformId": "提现平台",
  "withdrawHistory.thead.firstName": "名字",
  "withdrawHistory.thead.lastName": "姓氏",
  "withdrawHistory.thead.nickName": "昵称",
  "withdrawHistory.thead.document": "证件",
  "withdrawHistory.thead.source": "来源",
  "withdrawHistory.thead.createTime": "创建时间",
  "withdrawHistory.thead.modifyTime": "修改时间",
  "withdrawHistory.thead.action": "操作",
  "withdrawHistory.action.details": "详情",
  "withdrawHistory.action.pass": "通过",
  "withdrawHistory.action.reject": "拒绝",
  "withdrawHistory.tooltip.copyUserNo": "复制用户编号: {text}",
  "withdrawHistory.tooltip.userDetails": "显示用户详情",
  "withdrawHistory.copySuccess": "复制成功!",
  "withdrawHistory.confirm.content": "确定要{optWords}这个提现申请吗？",
  "withdrawHistory.confirm.ok": "确认",
  "withdrawHistory.confirm.cancel": "取消",
  "withdrawHistory.autoRefresh": "{seconds}秒后自动刷新列表",
  "withdrawHistory.autoWithdraw": "自动提现",
  "withdrawHistory.autoWithdraw.title": "{optWords}自动提现",
  "withdrawHistory.autoWithdraw.content": "确定要{optWords}自动提现吗？",
  "withdrawHistory.switch.open": "开启",
  "withdrawHistory.switch.close": "关闭",
  "withdrawHistory.form.platformId": "请选择平台",
  "withdrawHistory.thead.new": "新",
  "withdrawHistory.thead.inProgress": "进行中",
  "withdrawHistory.thead.paying": "支付中",
  "withdrawHistory.thead.success": "成功",
  "withdrawHistory.thead.fail": "失败",
  "withdrawHistory.thead.reject": "拒绝",
  "withdrawHistory.thead.operator": "操作人",
};
